module.exports = __webpack_public_path__ + "img/icon_2_29.5fa97f22.png";